// @ts-check
import './custom-shape-modal.css';
import { h } from 'preact';

import CloseButton from '../CloseButton';
import CustomShapeContent from '../SvgMap/components/CustomShapeContent';

const { __ } = wp.i18n;

/**
 * @param {object} props
 * @param {string=} props.name
 * @param {import('../../types').PlotNumber[]=} props.plotNumbers
 * @param {import('../../types').Status[]} props.statuses
 * @param {boolean=} props.isActive
 * @param {() => void} props.onClick
 * @param {(e: Event) => void} props.onClose
 * @returns
 */
export default function CustomShapeModal({
	name,
	plotNumbers,
	statuses,
	isActive = false,
	onClick,
	onClose
}) {
	return (
		<div
			className={`custom-shape-modal-container${isActive ? ' is-active' : ''}`}
			aria-hidden={!isActive}
			disabled={!isActive}
			tabIndex={!isActive ? -1 : undefined}
		>
			<div className="custom-shape-modal-body">
				<div className="custom-shape-modal-header-container">
					<CloseButton onClickHandler={onClose} isDisabled={!isActive} theme="dark" />
				</div>
				<CustomShapeContent
					name={name}
					plotNumbers={plotNumbers}
					statuses={statuses}
				/>
				<button className="button" onClick={onClick}>{__('View', 'real-estate-project')}</button>
			</div>
		</div>
	);
}
